// export const BASE_URL = 'http://3.134.233.50:8080/api' // dev url
export const BASE_URL = 'http://3.136.175.105:8080/api' //prod url

// export const bucketName = 'vendor-mgmt-dev' // dev bucket
export const bucketName = 'vendor-mgmt-prod' // prod bucket
// export const accessKeyId = 'AKIA4XZQTDJK7BM4IXMN' // dev id
export const accessKeyId = 'AKIATSIIXGB6WO7CE5FX' // prod id
// export const secretAccessKey = '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' // dev key
export const secretAccessKey = 'gd67TewGUynIAbED0M3VZBiSGy4f+v8rU+juFFaF' // prod key
// export const region = 'us-east-2' // dev region
export const region = 'us-east-2' // prod region
